import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Button,
  Alert
} from '@mui/material';
import {
  Cancel,
  ShoppingCart,
  Home
} from '@mui/icons-material';

const PaymentFailure = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [paymentInfo, setPaymentInfo] = useState(null);

  useEffect(() => {
    const externalReference = searchParams.get('external_reference');
    const paymentId = searchParams.get('payment_id');
    const collectionStatus = searchParams.get('collection_status');
    
    setPaymentInfo({
      externalReference,
      paymentId,
      collectionStatus
    });
  }, [searchParams]);

  return (
    <Container maxWidth="sm">
      <Box sx={{ minHeight: '60vh', display: 'flex', alignItems: 'center', py: 4 }}>
        <Card sx={{ width: '100%' }}>
          <CardContent className="text-center">
            <Cancel
              sx={{ fontSize: 80, color: 'error.main', mb: 2 }}
            />
            
            <Typography variant="h4" className="mb-md font-bold">
              Pago Rechazado
            </Typography>
            
            <Typography variant="body1" color="text.secondary" className="mb-lg">
              No se pudo procesar tu pago
            </Typography>

            {paymentInfo?.externalReference && (
              <Box className="mb-lg">
                <Card variant="outlined">
                  <CardContent>
                    <Box className="d-flex justify-between">
                      <Typography variant="body2" color="text.secondary">
                        Referencia:
                      </Typography>
                      <Typography variant="body2" className="font-semibold">
                        {paymentInfo.externalReference}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Box>
            )}

            <Alert severity="warning" className="mb-lg">
              <Typography variant="body2" className="mb-xs">
                Posibles razones:
              </Typography>
              <Typography variant="caption" component="div">
                • Fondos insuficientes<br />
                • Datos de tarjeta incorrectos<br />
                • Transacción rechazada por el banco<br />
                • Límite de compra excedido
              </Typography>
            </Alert>

            <Alert severity="info" className="mb-lg">
              Puedes intentar nuevamente con otro método de pago o contactar con tu banco.
            </Alert>

            <Box className="d-flex gap-sm justify-center">
              <Button
                variant="outlined"
                startIcon={<ShoppingCart />}
                onClick={() => navigate('/catalogo')}
              >
                Volver a nuestra cava
              </Button>
              <Button
                variant="contained"
                startIcon={<Home />}
                onClick={() => navigate('/')}
              >
                Volver al Inicio
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default PaymentFailure;

